var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMali(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5649 0.995188C19.8316 0.352063 17.9568 0 15.9997 0C14.0426 0 12.1678 0.352063 10.4345 0.995188L9.04321 16L10.4345 31.0048C12.1678 31.648 14.0426 32 15.9997 32C17.9568 32 19.8316 31.648 21.5649 31.0048L22.9562 16L21.5649 0.995188Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0001C32 9.12068 27.658 3.25593 21.5652 0.9953V31.005C27.658 28.7442 32 22.8796 32 16.0001V16.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0001C0 22.8796 4.342 28.7442 10.4348 31.0049V0.9953C4.342 3.25593 0 9.12068 0 16.0001V16.0001Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMali);
export default __webpack_public_path__ + "static/media/mali.9cbedaef.svg";
export { ForwardRef as ReactComponent };